import { FormBuilder, Validators } from '@angular/forms';
import { LocalizedTextDto } from '../dtos/localized-text.dto';
import { BookingConstraintDto } from '../dtos/booking-constraint.dto';

export class FormFactory {
  static createLocalizedTextsForm(fb: FormBuilder, localizedText?: LocalizedTextDto[]) {
    return fb.array(localizedText?.map(text => fb.group({
      language: [text.language, Validators.required],
      value: [text.value]
    })) || []);
  }

  static createBookingConstraintsForm(fb: FormBuilder, bookingConstraintDtos?: BookingConstraintDto[]) {
    return fb.array(bookingConstraintDtos?.map(bookingConstraintDto => fb.group({
      weekDay: [bookingConstraintDto.weekDay, Validators.required],
      startTimeMinutesAfterMidnight: [bookingConstraintDto.startTimeMinutesAfterMidnight, Validators.required],
      endTimeMinutesAfterMidnight: [bookingConstraintDto.endTimeMinutesAfterMidnight, Validators.required]
    })) || []);
  }
}
